import { usePermissions } from '@/features/auth';
import type { QuickActionPrompt } from './chat-content';
import { useAiChatSimplifiedMode } from './use-ai-chat-simplified-mode';
import { useCanUseAdminPrompts } from './use-can-use-admin-prompts';

/**
 * Whether a quick-action prompt is offered: the admin gate, any one of the permissions it
 * requires, and the simplified mode. A prompt that only ever answers "you can't" is noise.
 */
export function useQuickActionFilter(): (prompt: QuickActionPrompt) => boolean {
  const canUseAdminPrompts = useCanUseAdminPrompts();
  const { hasPermission } = usePermissions();
  const simplifiedMode = useAiChatSimplifiedMode();

  return prompt =>
    (canUseAdminPrompts || prompt.adminOnly !== true) &&
    (prompt.requires === undefined || prompt.requires.some(hasPermission)) &&
    !(simplifiedMode && prompt.hiddenInSimplifiedMode === true);
}
